(() => {
  'use strict';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const shopifyCommerce = Boolean(document.documentElement.dataset.shopifyCommerce);
  const showDialog = dialog => { if (dialog && !dialog.open) dialog.showModal(); };
  const closeDialog = button => button.closest('dialog')?.close();
  $$('[data-close]').forEach(button => button.addEventListener('click', () => closeDialog(button)));
  $$('dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }));

  const mainImage = $('#product-image');
  const imageButtons = $$('.thumbnail[data-image]');
  imageButtons.forEach((button, index) => button.addEventListener('click', () => {
    if (!mainImage) return;
    mainImage.src = button.dataset.image;
    mainImage.alt = button.dataset.alt || '';
    imageButtons.forEach(item => { const selected = item === button; item.classList.toggle('selected', selected); item.setAttribute('aria-pressed', String(selected)); });
    $$('[data-gallery-index]').forEach(dot => { const active = Number(dot.dataset.galleryIndex) === index; dot.classList.toggle('selected', active); dot.setAttribute('aria-pressed', String(active)); });
    const number = $('[data-image-index]');
    if (number) number.textContent = String(index + 1).padStart(2, '0');
  }));
  const nextGalleryImage = direction => {
    const current = Math.max(0, imageButtons.findIndex(button => button.classList.contains('selected')));
    if (imageButtons.length) imageButtons[(current + direction + imageButtons.length) % imageButtons.length].click();
  };
  $('[data-gallery-next]')?.addEventListener('click', () => nextGalleryImage(1));
  $$('[data-gallery-index]').forEach(dot => dot.addEventListener('click', () => imageButtons[Number(dot.dataset.galleryIndex)]?.click()));
  let galleryTouch = null;
  $('.main-photo')?.addEventListener('touchstart', event => {
    const touch = event.changedTouches[0]; galleryTouch = { x: touch.clientX, y: touch.clientY };
  }, { passive: true });
  $('.main-photo')?.addEventListener('touchend', event => {
    if (!galleryTouch) return;
    const touch = event.changedTouches[0];
    const dx = touch.clientX - galleryTouch.x, dy = touch.clientY - galleryTouch.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) nextGalleryImage(dx < 0 ? 1 : -1);
    galleryTouch = null;
  }, { passive: true });
  $('[data-zoom]')?.addEventListener('click', () => {
    const dialog = $('#zoom-dialog');
    const enlarged = dialog && $('img', dialog);
    if (!mainImage || !enlarged) return;
    enlarged.src = mainImage.src;
    enlarged.alt = mainImage.alt;
    showDialog(dialog);
  });

  $$('[data-carousel]').forEach(carousel => {
    const track = $('[data-carousel-track]', carousel);
    const previous = $('[data-carousel-prev]', carousel);
    const next = $('[data-carousel-next]', carousel);
    const counter = $('[data-carousel-count]', carousel);
    const toggle = $('[data-carousel-toggle]', carousel);
    if (!track) return;
    const cards = Array.from(track.children);
    if (!cards.length) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const automatic = carousel.dataset.carouselAutoplay === 'true' && Boolean(toggle) && cards.length > 1;
    const clones = automatic ? cards.map(card => {
      const clone = card.cloneNode(true);
      clone.dataset.carouselClone = '';
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.inert = true;
      [clone, ...clone.querySelectorAll('[id]')].forEach(element => element.removeAttribute('id'));
      clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(element => element.setAttribute('tabindex', '-1'));
      track.append(clone);
      return clone;
    }) : [];
    let current = 0, loopDistance = 0, position = 0, lastTime = 0, frame = 0, settleTimer = 0;
    let running = false, userPaused = false, hovering = false, visible = !('IntersectionObserver' in window);
    let dragging = null;
    const looping = () => automatic && !motion.matches && loopDistance > 0;
    const normalize = value => loopDistance > 0 ? ((value % loopDistance) + loopDistance) % loopDistance : value;
    const offset = card => card.offsetLeft - cards[0].offsetLeft;
    const updateCarousel = () => {
      const at = looping() ? normalize(track.scrollLeft) : track.scrollLeft;
      let nearest = 0, distance = Infinity;
      cards.forEach((card, index) => {
        const delta = Math.abs(offset(card) - at);
        if (delta < distance) { nearest = index; distance = delta; }
      });
      if (looping() && loopDistance - at < distance) nearest = 0;
      if (!looping() && track.scrollLeft > 0 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) nearest = cards.length - 1;
      current = nearest;
      if (previous) previous.disabled = !looping() && current === 0;
      if (next) next.disabled = !looping() && current === cards.length - 1;
      const count = `${String(current + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      if (counter && counter.textContent !== count) counter.textContent = count;
    };
    const stop = () => {
      running = false;
      window.cancelAnimationFrame(frame);
      frame = 0;
      lastTime = 0;
    };
    const tick = timestamp => {
      if (!running) return;
      if (lastTime) position = normalize(position + 24 * Math.min(timestamp - lastTime, 50) / 1000);
      lastTime = timestamp;
      // Keep a fractional position so the loop advances evenly at every refresh rate.
      track.scrollLeft = position;
      updateCarousel();
      frame = window.requestAnimationFrame(tick);
    };
    const schedule = () => {
      stop();
      if (toggle) {
        toggle.disabled = motion.matches || !automatic;
        toggle.setAttribute('aria-pressed', String(userPaused));
        toggle.setAttribute('aria-label', motion.matches ? 'Automatic motion disabled by your motion preference' : userPaused ? 'Resume automatic community cards' : 'Pause automatic community cards');
        toggle.textContent = userPaused || motion.matches ? '▷' : 'Ⅱ';
      }
      if (counter) counter.setAttribute('aria-live', userPaused || motion.matches ? 'polite' : 'off');
      if (!looping() || userPaused || !visible || document.hidden || hovering || dragging || (carousel.contains(document.activeElement) && document.activeElement !== toggle)) return;
      window.clearTimeout(settleTimer);
      position = normalize(track.scrollLeft);
      running = true;
      frame = window.requestAnimationFrame(tick);
    };
    const measure = () => {
      const saved = normalize(track.scrollLeft);
      const enable = automatic && !motion.matches;
      clones.forEach(clone => { clone.hidden = !enable; });
      carousel.classList.toggle('is-marquee', enable);
      loopDistance = enable && clones[0] ? offset(clones[0]) : 0;
      track.scrollLeft = looping() ? normalize(saved) : Math.min(saved, track.scrollWidth - track.clientWidth);
      position = track.scrollLeft;
      updateCarousel();
      schedule();
    };
    const pause = () => { userPaused = true; schedule(); };
    const move = direction => {
      pause();
      let index = current + direction;
      let destination;
      if (looping()) {
        if (index < 0) {
          track.scrollLeft = current === 0 && normalize(track.scrollLeft) < loopDistance / 2 ? normalize(track.scrollLeft) + loopDistance : normalize(track.scrollLeft);
          destination = offset(cards[cards.length - 1]);
        } else if (index >= cards.length) {
          track.scrollLeft = normalize(track.scrollLeft);
          destination = loopDistance;
        } else {
          track.scrollLeft = normalize(track.scrollLeft);
          destination = offset(cards[index]);
        }
      } else destination = offset(cards[Math.max(0, Math.min(cards.length - 1, index))]);
      track.scrollTo({ left: destination, behavior: motion.matches ? 'instant' : 'smooth' });
    };
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    toggle?.addEventListener('click', () => { userPaused = !userPaused; schedule(); });
    track.addEventListener('scroll', () => {
      updateCarousel();
      if (running) return;
      position = track.scrollLeft;
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(() => {
        if (looping() && !running && !dragging && track.scrollLeft >= loopDistance) track.scrollLeft = normalize(track.scrollLeft);
      }, 160);
    }, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
    });
    track.addEventListener('wheel', pause, { passive: true });
    track.addEventListener('pointerdown', event => {
      pause();
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a,button,input,select,textarea')) return;
      dragging = { id: event.pointerId, x: event.clientX, left: track.scrollLeft };
      track.setPointerCapture(event.pointerId);
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', event => {
      if (!dragging || event.pointerId !== dragging.id) return;
      track.scrollLeft = dragging.left + dragging.x - event.clientX;
    });
    const endDrag = () => {
      dragging = null;
      track.classList.remove('is-dragging');
      if (looping() && track.scrollLeft >= loopDistance) track.scrollLeft = normalize(track.scrollLeft);
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', endDrag);
    carousel.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; schedule(); } });
    carousel.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovering = false; schedule(); } });
    carousel.addEventListener('focusin', schedule);
    carousel.addEventListener('focusout', () => window.setTimeout(schedule, 0));
    document.addEventListener('visibilitychange', schedule);
    motion.addEventListener('change', measure);
    window.addEventListener('resize', measure, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(track);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: 0.3 }).observe(carousel);
    }
    measure();
  });

  const menuButton = $('.menu-button');
  const navigation = $('#navigation');
  const closeMenu = () => { navigation?.classList.remove('open'); menuButton?.setAttribute('aria-expanded', 'false'); menuButton?.setAttribute('aria-label', 'Open navigation'); };
  menuButton?.addEventListener('click', () => {
    const open = navigation?.classList.toggle('open');
    menuButton.setAttribute('aria-expanded', String(Boolean(open)));
    menuButton.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
  });
  $$('#navigation a').forEach(link => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });
  document.addEventListener('click', event => { if (navigation?.classList.contains('open') && !navigation.contains(event.target) && !menuButton?.contains(event.target)) closeMenu(); });

  const information = {
    contact: ['Let’s talk.', '<p>Have a question about the stickers, a delivery or an order? Send a note to customer care. To cancel an order before dispatch, include your order number and request cancellation.</p><a class="text-link" href="https://ejwx0t-w1.myshopify.com/pages/contact">Visit customer care <span aria-hidden="true">↗</span></a>'],
    shipping: ['The details, clearly.', '<p>Worldwide shipping is free. Estimated delivery: 7–12 calendar days from your order, including processing and transit. We will email you when your order ships. Import duties or taxes may still apply.</p><p>Try the stickers and contact us within 30 calendar days of delivery for a full refund. No explanation needed. We’ll provide a prepaid return label and return instructions, then issue the refund to your original payment method within 5 business days of receiving your return. Bank posting time may vary.</p><p>You can also cancel an order before dispatch for a full refund. Contact customer care with your order number.</p><p><a class="text-link" href="https://ejwx0t-w1.myshopify.com/policies/refund-policy">Read our full returns policy ↗</a></p><a class="text-link" href="https://ejwx0t-w1.myshopify.com/pages/contact">Contact customer care <span aria-hidden="true">↗</span></a>'],
    returns: ['30-day money-back guarantee.', '<p>Try the stickers and contact us within 30 calendar days of delivery for a full refund. No explanation needed.</p><p>We’ll provide a prepaid return label and return instructions. Your refund will be issued to your original payment method within 5 business days of receiving the return. Bank posting time may vary.</p><p>You can also cancel an order before dispatch for a full refund.</p><a class="text-link" href="https://ejwx0t-w1.myshopify.com/policies/refund-policy">Read our full returns policy <span aria-hidden="true">↗</span></a>'],
    privacy: ['Your details, thoughtfully handled.', '<p>Email updates are optional, and you can unsubscribe at any time. A subscription does not place an order or reserve stock.</p><p>Read the store’s privacy policy before submitting your details.</p><a class="text-link" href="https://ejwx0t-w1.myshopify.com/policies/privacy-policy">Read privacy policy <span aria-hidden="true">↗</span></a>'],
    account: ['Your little corner.', '<p>Sign in to see your orders and manage your customer details.</p><a class="text-link" href="https://ejwx0t-w1.myshopify.com/account">Go to your account <span aria-hidden="true">↗</span></a>'],
    reviews: ['Join the conversation.', '<p>Have a question, a thought about the product, or an experience to share? Send your comment to Lilac Signal and let us know whether you would like it considered for this page.</p><p>Comments should reflect your own views or experience.</p><a class="text-link" href="https://ejwx0t-w1.myshopify.com/pages/contact">Share your thoughts <span aria-hidden="true">↗</span></a>']
  };
  $$('[data-info]').forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    const content = information[button.dataset.info];
    const dialog = $('#info-dialog');
    if (!content || !dialog) return;
    const title = $('#info-title', dialog);
    const body = $('#info-content', dialog);
    if (!title || !body) return;
    title.textContent = content[0];
    body.innerHTML = content[1];
    showDialog(dialog);
  }));

  const searchInput = $('#search');
  const results = $('#search-results');
  const productSearchUrl = shopifyCommerce ? (document.documentElement.dataset.shopifyProductUrl || '#product') : '#product';
  const normalizeSearch = value => value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const searchItems = [
    ['Lilac Signal Drink Testing Nail Stickers', productSearchUrl, 'stickers nail heart product pack packs shop price lilac signal preorder pre order 10 20 40 10-pack 20-pack 40-pack'],
    ['Community comments', '#reviews', 'review customer community comment story experience'],
    ['Testing essentials', '#good-to-know', 'screen test safety safe result limits substances'],
    ['Shipping, returns & product questions', '#faq', 'shipping delivery returns refund currency country help faq how'],
    ['Email updates & availability', '#newsletter', 'email signup updates newsletter availability stock notify']
  ];
  const renderSearch = () => {
    if (!results || !searchInput) return;
    const query = normalizeSearch(searchInput.value);
    const terms = query.split(/\s+/).filter(Boolean);
    const matches = searchItems.filter(([name, href, keywords]) => {
      const searchable = normalizeSearch(`${name} ${keywords}`);
      return terms.every(term => searchable.includes(term));
    });
    results.replaceChildren();
    if (!matches.length) { const note = document.createElement('p'); note.textContent = 'Nothing found. Try “stickers”, “shipping” or “testing”.'; results.append(note); return; }
    matches.forEach(([name, href]) => {
      const link = document.createElement('a'); link.href = href.startsWith('#') ? (document.querySelector(href) ? href : (document.documentElement.dataset.shopifyRoot || '/') + href) : href; link.textContent = name;
      const arrow = document.createElement('span'); arrow.textContent = '↗'; arrow.setAttribute('aria-hidden', 'true'); link.append(arrow);
      link.addEventListener('click', () => $('#search-dialog')?.close()); results.append(link);
    });
  };
  $$('[data-open-search]').forEach(button => button.addEventListener('click', () => { showDialog($('#search-dialog')); renderSearch(); searchInput?.focus(); }));
  searchInput?.addEventListener('input', renderSearch);
  renderSearch();

  const sticky = $('.sticky-buy');
  const offer = $('.purchase-action');
  const footer = $('.footer');
  let offerVisible = true;
  let footerVisible = false;
  const updateSticky = () => { if (sticky) sticky.hidden = offerVisible || footerVisible; };
  if (sticky && offer && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => { offerVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > window.innerHeight; updateSticky(); }, { threshold: 0 }).observe(offer);
    if (footer) new IntersectionObserver(entries => { footerVisible = entries[0].isIntersecting; updateSticky(); }, { threshold: 0 }).observe(footer);
  }
  $$('[data-year]').forEach(node => { node.textContent = String(new Date().getFullYear()); });
  const backTop = $('[data-back-top]');
  if (backTop) {
    const updateBackTop = () => { backTop.hidden = window.scrollY < 500; };
    window.addEventListener('scroll', updateBackTop, { passive: true });
    backTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
    updateBackTop();
  }


  if (!shopifyCommerce) {
    // ECB reference rates dated 2026-10-14. Base prices are GBP; checkout controls final market prices.
    const eurRates = { EUR:1, GBP:0.84385, USD:1.1195, JPY:177.39, DKK:7.4754, PLN:4.3658, SEK:11.1580, CHF:0.9330, NOK:10.6035, AUD:1.5971, BRL:5.6246, CAD:1.5918, HKD:8.7859, INR:106.5283, MXN:20.5600, NZD:1.9941, SGD:1.4359, ZAR:18.4382 };
    const regionCurrencies = { GB:'GBP', US:'USD', AU:'AUD', CA:'CAD', IN:'INR', JP:'JPY', CH:'CHF', NZ:'NZD', SG:'SGD', HK:'HKD', SE:'SEK', NO:'NOK', DK:'DKK', PL:'PLN', ZA:'ZAR', BR:'BRL', MX:'MXN', AT:'EUR', BE:'EUR', CY:'EUR', DE:'EUR', EE:'EUR', ES:'EUR', FI:'EUR', FR:'EUR', GR:'EUR', HR:'EUR', IE:'EUR', IT:'EUR', LT:'EUR', LU:'EUR', LV:'EUR', MT:'EUR', NL:'EUR', PT:'EUR', SI:'EUR', SK:'EUR' };
    const packPrices = { 10:17.5, 20:28.7, 40:40.45 };
    let currency = 'USD';
    let selectedPack = '10';
    try { const region = new Intl.Locale(navigator.language || 'en-US').region; currency = regionCurrencies[region] || 'USD'; const saved = localStorage.getItem('lilac-signal-currency'); if (saved && eurRates[saved]) currency = saved; } catch (_) {}
    const formatMoney = amount => new Intl.NumberFormat(navigator.language || 'en-GB', { style:'currency', currency, currencyDisplay:'narrowSymbol' }).format(Number(amount) * eurRates[currency] / eurRates.GBP);
    const updatePrices = () => {
      $$('[data-main-price]').forEach(node => { node.dataset.money = String(packPrices[selectedPack]); });
      $$('[data-money]').forEach(node => { node.textContent = formatMoney(node.dataset.money); });
      $$('[data-pack-count]').forEach(node => { node.textContent = `${selectedPack} stickers`; });
      $$('[data-currency]').forEach(select => { select.value = currency; });
      $$('[data-currency-note]').forEach(node => { node.textContent = `${currency} · Display currency`; });
    };
    $$('[data-pack]').forEach(button => button.addEventListener('click', () => {
      if (!packPrices[button.dataset.pack]) return;
      selectedPack = button.dataset.pack;
      $$('[data-pack]').forEach(item => { const selected = item.dataset.pack === selectedPack; item.classList.toggle('selected', selected); item.setAttribute('aria-pressed', String(selected)); });
      updatePrices();
    }));
    $$('[data-currency]').forEach(select => select.addEventListener('change', () => {
      if (!eurRates[select.value]) return;
      currency = select.value;
      try { localStorage.setItem('lilac-signal-currency', currency); } catch (_) {}
      updatePrices();
    }));
    updatePrices();
    $$('[data-cart]').forEach(button => button.addEventListener('click', () => showDialog($('#bag-dialog'))));
    $$('[data-notify]').forEach(button => button.addEventListener('click', () => {
      const newsletter = $('#newsletter');
      newsletter?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      $('#email')?.focus({ preventScroll:true });
    }));
    $$('.newsletter-form[data-static-form]').forEach(form => form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const result = $('.form-result', form);
      if (!result) return;
      result.replaceChildren();
      const message = document.createElement('span'); message.textContent = 'Finish subscribing in our store. Your email has not been submitted here. ';
      const link = document.createElement('a'); link.href = 'https://ejwx0t-w1.myshopify.com/#newsletter'; link.textContent = 'Continue to email signup ↗'; link.style.textDecoration = 'underline';
      result.append(message, link);
    }));
  }
})();
